import Swal from 'sweetalert2';
import './toaster.css';

const Toast = Swal?.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  showCloseButton: true,
  width: 'auto',
  timerProgressBar: true,
  iconColor: '#0A8BC7',
  customClass: {
    container: 'custom-toast',
  },
});

type ToastType = 'success' | 'error' | 'warning' | 'info';

const makeToast = (type: ToastType, msg: string, timer?: number) => {
  Toast?.fire({
    icon: type,
    title: msg,
    timer: timer || 6000,
  });
};

export default makeToast;
